import { combineReducers } from 'redux'
import mainReducer from './mainReducer.js'
import blogReducer from './blogReducer.js'

export default combineReducers({
    main:mainReducer,
    blog:blogReducer
})